<template>
    <div class="auto-scroll-container">
        <!-- 固定表头 -->
        <div class="scroll-header">
            <div class="item">用户</div>
            <div class="item">操作</div>
            <div class="item">金额</div>
            <div class="item">时间</div>
        </div>

        <!-- 自动滚动的内容区 -->
        <div class="scroll-content" :style="{ animationDuration: `${duration}s` }">
            <!-- 数据重复两份，实现无缝 -->
            <div v-for="(item, index) in doubleList" :key="index" class="row">
                <div class="cell">{{ item.user }}</div>
                <div class="cell">{{ item.action }}</div>
                <div class="cell">{{ item.amount }}</div>
                <div class="cell">{{ item.time }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: [
                { user: '0x0x..0', action: '提币', amount: '100', time: '2025/09/12 00:00:00' },
                { user: '0x0x..0', action: '提币', amount: '100', time: '2025/09/12 00:00:00' },
                { user: '0x0x..0', action: '提币', amount: '100', time: '2025/09/12 00:00:00' },
                { user: '0x0x..0', action: '提币', amount: '100', time: '2025/09/12 00:00:00' }
            ],
            duration: 8 // 滚动一圈的时间（秒）
        }
    },
    computed: {
        doubleList() {
            return [...this.list, ...this.list]
        }
    }
}
</script>

<style scoped></style>